import React from 'react';
import LocationPageTemplate from './LocationPageTemplate';

export default function MurphyPage() {
  return (
    <LocationPageTemplate
      city="Murphy"
      slug="murphy"
      neighborhoods="From Maxwell Creek to Stratford Crossing, we service Murphy sprinkler systems daily."
      localCopy={[
        "Murphy's mix of newer residential developments and spacious lots means irrigation systems here cover large turf areas and run heavily in July and August. We see everything from smart controller upgrades to cracked lateral lines caused by settling soil.",
        "The clay soils of Murphy expand and contract dramatically between wet and dry seasons, placing immense stress on PVC pipe joints. We carry high-pressure fittings and heavy-duty schedule 40 PVC to make permanent, robust repairs on our first visit.",
        "Murphy municipal code requires backflow preventer installation on all active irrigation connections. AAA Irrigation handles the physical installation, coordinates the testing through a licensed partner, and manages the paperwork directly with the City of Murphy.",
      ]}
      reviewQuote="The technician diagnosed a low pressure issue that we'd been fighting for weeks. Turns out it was a tree root pinching a lateral line. Excellent work!"
      reviewAuthor="Sarah M. — Murphy, TX"
    />
  );
}
